// extracted by mini-css-extract-plugin
export default {"container":"XE1AB2","input-container":"EwTKg4","dropdown-input":"WKBaQx","skeleton":"xZdDNY","mode-switcher-button":"fPrK0s","mode-switcher-dropdown-menu":"pn30YG"};